import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { article_path } from '@routes';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import { LatestProArticles } from '../../interfaces/homepage';
import Highlight from '../FeedItems/Highlight';
import TimeAgo from '../TimeAgo';
import { SectionTitle } from './SectionTitle';

interface LatestInProProps {
  latestProArticles: LatestProArticles[];
}

const LatestInPro = ({ latestProArticles }: LatestInProProps) => {
  const { Track, trackEvent } = useEventTracking({ location: TrackingLocation.LatestProArticles });
  return (
    <Track>
      <div className="mb-64">
        <SectionTitle
          title={
            <>
              Latest in{' '}
              <span className="bg-pro-gold px-10 py-4 text-overline-md text-white">Pro</span>
            </>
          }
        />
        {latestProArticles.map(({ highlight, publishedAt, slug, title }, index) => (
          <div key={`${title}-${index}`} data-test={`pro-${title}`} className="mb-32">
            {highlight && <Highlight highlight={highlight} className="!text-caption-sm" />}
            <h2 className="my-4 font-suisse-screen text-body-md text-primary-black lg:text-subheadline-sm">
              <a
                onClickCapture={() =>
                  trackEvent(click({ clickTarget: ClickTarget.Headline, clickText: title }))
                }
                href={article_path(slug)}
                className="text-inherit hover:text-primary-magenta"
              >
                {title}
              </a>
            </h2>
            <TimeAgo className="inline-block text-grayscale-gray" date={publishedAt} />
          </div>
        ))}
      </div>
    </Track>
  );
};

export default LatestInPro;
